import { motion, useInView } from "framer-motion"
import { graphql, Link, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import "./Footer.css"
import SubscribePopup from '../Popups/SubscibePopup'

const Footer = () => {
  const ref = useRef(null)
  const [hasPlayed, setHasPlayed] = useState(false)
  const isInView = useInView(ref)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const [isPopupVisible, setIsPopupVisible] = useState(false)
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  
  const showNewsletterThankYouMessage = () => {
    setIsFormSubmitted(true)
    setIsPopupVisible(true)
  }

  const footerData = useStaticQuery(graphql`
    query {
      wp {
        themeGeneralSettings {
          fluxDna {
            footerLogo {
              altText
              mediaItemUrl
              title
            }
            footerLogoText
            newsletterHeading
            footerButton {
              target
              title
              url
            }
            footerMenuHeading {
              target
              title
              url
            }
            footerMenu {
              menu {
                target
                title
                url
              }
            }
            footerMenu1Heading {
              target
              title
              url
            }
            footerMenu1 {
              menu {
                target
                title
                url
              }
            }
            footerMenu2Heading {
              target
              title
              url
            }
            footerMenu2 {
              menu {
                target
                title
                url
              }
            }
            footerMenu3 {
              menu {
                target
                title
                url
              }
            }
            termsMenu {
              menu {
                target
                title
                url
              }
            }
            phone
            email
            copyright
            footerSocialMedia {
              link {
                target
                title
                url
              }
              icon {
                altText
                mediaItemUrl
                title
              }
            }
          }
        }
      }
    }
  `)
  const footerDataList = footerData.wp.themeGeneralSettings.fluxDna
  const [isLoading, setIsLoading] = useState(false)
  const [form, setForm] = useState({
    input_2: "",
    input_3: "",
    input_4: "",
    input_6: "Guest",
  })

  const [formError, setFormError] = useState({
    input_2: "",
    input_3: "",
    input_4: "",
  })

  return (
    <React.Fragment>
      <SubscribePopup />
      <motion.footer
        initial="hidden"
        animate={isInView || hasPlayed ? "show" : "hidden"}
        variants={sectionShow}
        className="footer"
      >
        <motion.div
          ref={ref}
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className="newsletter lg:py-45 py-40 border-b-1 border-white-100 border-opacity-20 bg-white-200 bg-opacity-30"
        >
          <div className="container-fluid">
            <div className="flex flex-wrap items-center justify-between">
              {footerDataList?.newsletterHeading && (
                <motion.div variants={animFade} className="title title-grey">
                  <h6 className="text-grey-400 text-30 font-800 font-headingSecondary">
                    {footerDataList.newsletterHeading}
                  </h6>
                </motion.div>
              )}
              <motion.div
                variants={animFade}
                className="xlscreen:pt-40 w-[80%] desktop3:w-[75%] large_desktop:w-[75%] desktop_small:w-[72%] laptop:w-[70%] xlscreen:w-full"
              >
                {!isFormSubmitted ? (
                  <div className="gform_wrapper flex flex-wrap ipad:flex-col justify-between items-start ipad:items-start">
                    <div className="gform_body w-full px-50 xlscreen:pl-0 mdscreen:pr-0">
                      <ul className="flex flex-wrap -ml-50">
                        <li>
                          <input
                            type="text"
                            value={form.input_2}
                            onChange={e => {
                              setForm({
                                ...form,
                                input_2: e.target.value,
                              })
                              setFormError({
                                ...formError,
                                input_2: "",
                              })
                            }}
                            placeholder="First Name"
                          />
                          {formError.input_2 && (
                            <div className="error">
                              <span className="text-red">
                                {formError.input_2}
                              </span>
                            </div>
                          )}
                        </li>
                        <li>
                          <input
                            type="text"
                            value={form.input_3}
                            onChange={e => {
                              setForm({
                                ...form,
                                input_3: e.target.value,
                              })
                              setFormError({
                                ...formError,
                                input_3: "",
                              })
                            }}
                            placeholder="Last Name"
                          />
                          {formError.input_3 && (
                            <div className="error">
                              <span className="text-red">
                                {formError.input_3}
                              </span>
                            </div>
                          )}
                        </li>
                        <li>
                          <input
                            type="text"
                            value={form.input_4}
                            onBlur={e => {
                              var value = e.target.value
                              var pattern =
                                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                              if (!pattern.test(value)) {
                                setForm({ ...form, input_4: "" })
                                setFormError({
                                  ...formError,
                                  input_4: "Please enter valid email.",
                                })
                              }
                            }}
                            onChange={e => {
                              setForm({
                                ...form,
                                input_4: e.target.value,
                              })
                              setFormError({
                                ...formError,
                                input_4: "",
                              })
                            }}
                            placeholder="Email Address"
                          />
                          {formError.input_4 && (
                            <div className="error">
                              <span className="text-red">
                                {formError.input_4}
                              </span>
                            </div>
                          )}
                        </li>
                        <li className="radio-group">
                          <label className="radiol-label">
                            <input
                              type="radio"
                              name="footerUserType"  // Unique name for footer form
                              value="Guest"
                              checked={form.input_6 === "Guest"}
                              onChange={e => setForm({ ...form, input_6: e.target.value })}
                              className="radio-input"
                            />
                            Guest
                          </label>
                          <label className="radiol-label">
                            <input
                              type="radio"
                              name="footerUserType"  // Unique name for footer form
                              value="Agent"
                              checked={form.input_6 === "Agent"}
                              onChange={e => setForm({ ...form, input_6: e.target.value })}
                              className="radio-input"
                            />
                            Agent
                          </label>
                        </li>
                      </ul>
                    </div>
                    <div className="gform_footer smscreen2:mt-15 ipad:mt-15 smscreen:w-full">
                      <button
                        className="btn btn-grey mdscreen:w-full"
                        onClick={() => {
                          var validRegex =
                            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                          setFormError({
                            ...formError,
                            input_2:
                              form.input_2 === ""
                                ? "Please enter first name."
                                : "",
                            input_3:
                              form.input_3 === ""
                                ? "Please enter last name."
                                : "",
                            input_4:
                              form.input_4 === "" ||
                                !form.input_4.match(validRegex)
                                ? "Please enter valid email."
                                : "",
                          })

                          if (
                            form.input_4 !== "" &&
                            form.input_2 !== "" &&
                            form.input_3 !== ""
                          ) {
                            document.body.classList.add("loader")
                            setIsLoading(true)
                            const requestOptions = {
                              method: "POST",
                              headers: { "Content-Type": "application/json" },
                              body: JSON.stringify(form),
                            }
                            const url = `${process.env.GATSBY_SITE_URL}wp-json/gf/v2/forms/${process.env.GATSBY_NEWSLETTER_FORM_ID}/submissions`
                            setFormError({
                              ...formError,
                            })
                            fetch(url, requestOptions).then(response => {
                              if (response.status === 200) {
                                document.body.classList.remove("loader")
                                setIsLoading(false)
                                showNewsletterThankYouMessage()
                              } else {
                                setFormError({
                                  ...formError,
                                })
                              }
                            })
                          }
                        }}
                      >
                        <span>{isLoading ? "Loading" : "Sign Up"}</span>
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="newsletter-message">
                    <p>Thank you for signing up to our newsletter!</p>
                  </div>
                )}
              </motion.div>
            </div>
          </div>
        </motion.div>
        <div className="footer-navbar py-70 text-white-100 lgscreen:py-30 lgscreen:pb-0 bg-grey-100">
          <div className="container-fluid-sm pr-150 laptop:pr-20">
            <div className="flex flex-wrap justify-between">
              <motion.div
                variants={animFade}
                className="footer-navbar1 ipad:w-full ipad:text-center ipad:mb-50"
              >
                {footerDataList?.footerLogo && (
                  <Link to="/">
                    <img
                      src={footerDataList.footerLogo.mediaItemUrl}
                      className="mx-auto"
                      width={190}
                      height={82}
                      loading="lazy"
                      alt={footerDataList.footerLogo.title}
                    />
                  </Link>
                )}
                {footerDataList?.footerLogoText && (
                  <span className="text-13 font-primary leading-16 -tracking-[0.3px] font-400 mx-auto text-center inline-block pt-15">
                    {footerDataList.footerLogoText}
                  </span>
                )}
              </motion.div>
              <motion.div
                variants={animFade}
                className="footer-menu mdscreen:w-full mdscreen:text-center mdscreen:mb-30"
              >
                {footerDataList?.footerMenuHeading && (
                  <h6 className="font-headingSecondary text-22 font-400 tracking-[0.01em] text-white-100">
                    <Link
                      to={footerDataList.footerMenuHeading.url}
                      className="hover:opacity-50 transition-common"
                    >
                      {footerDataList.footerMenuHeading.title}
                    </Link>
                  </h6>
                )}
                {footerDataList?.footerMenu && (
                  <ul className="grid gap-20 pt-25">
                    {footerDataList.footerMenu.map((item, i) => (
                      <li key={i}>
                        <Link
                          to={item.menu.url}
                          className="text-15 laptop:text-13 xlscreen:text-12 uppercase tracking-[0.02em] font-400 hover:opacity-50"
                          target={item.menu.target}
                        >
                          {parse(item.menu.title)}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
                {footerDataList?.footerMenu3 && (
                  <ul className="grid gap-20 pt-25">
                    {footerDataList.footerMenu3.map((item, j) => (
                      <li
                        className="font-headingSecondary text-22 font-400 tracking-[0.01em] text-white-100"
                        key={j}
                      >
                        <Link
                          to={item.menu.url}
                          target={item.menu.target}
                          className="hover:opacity-50 transition-common"
                        >
                          {parse(item.menu.title)}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </motion.div>
              <motion.div
                variants={animFade}
                className="footer-menu mdscreen:w-full mdscreen:text-center mdscreen:mb-30"
              >
                {footerDataList?.footerMenu1Heading && (
                  <h6 className="font-headingSecondary text-22 font-400 tracking-[0.01em] text-white-100 transition-common">
                    <Link
                      to={footerDataList.footerMenu1Heading.url}
                      className="hover:opacity-50"
                    >
                      {footerDataList.footerMenu1Heading.title}
                    </Link>
                  </h6>
                )}
                {footerDataList?.footerMenu1 && (
                  <ul className="grid gap-20 mt-25">
                    {footerDataList.footerMenu1.map((item, k) => (
                      <li key={k}>
                        <Link
                          to={item.menu.url}
                          className="text-15 laptop:text-13 xlscreen:text-12 uppercase tracking-[0.02em] font-400 hover:opacity-50"
                          target={item.menu.target}
                        >
                          {parse(item.menu.title)}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </motion.div>
              <motion.div
                variants={animFade}
                className="footer-menu mdscreen:w-full mdscreen:text-center mdscreen:mb-30"
              >
                {footerDataList?.footerMenu2Heading && (
                  <h6 className="font-headingSecondary text-22 font-400 tracking-[0.01em] text-white-100 transition-common">
                    <Link
                      to={footerDataList.footerMenu2Heading.url}
                      className=" hover:opacity-50"
                    >
                      {footerDataList.footerMenu2Heading.title}
                    </Link>
                  </h6>
                )}
                {footerDataList?.footerMenu2 && (
                  <ul className="grid gap-20 mt-25">
                    {footerDataList.footerMenu2.map((item, l) => (
                      <li key={l}>
                        <Link
                          to={item.menu.url}
                          className="text-15 laptop:text-13 xlscreen:text-12 uppercase tracking-[0.02em] font-400 hover:opacity-50"
                          target={item.menu.target}
                        >
                          {parse(item.menu.title)}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </motion.div>
              <motion.div
                variants={animFade}
                className="cinfo text-right mdscreen:w-full mdscreen:text-center mdscreen:pt-15"
              >
                {footerDataList?.footerButton && (
                  <div className="btn-custom">
                    <Link
                      to={footerDataList.footerButton.url}
                      className="btn btn-white"
                      target={footerDataList.footerButton.target}
                    >
                      {footerDataList.footerButton.title}
                    </Link>
                  </div>
                )}
                <div className="cinfolink flex flex-col gap-10 justify-end pt-20">
                  {footerDataList?.phone && (
                    <Link
                      className="text-13 text-white-100 font-400 hover:opacity-50"
                      to={`tel:${footerDataList.phone}`}
                    >
                      {footerDataList.phone}
                    </Link>
                  )}
                  {footerDataList?.email && (
                    <Link
                      className="text-13 text-white-100 font-400 hover:opacity-50"
                      to={`mailto:${footerDataList.email}`}
                    >
                      {footerDataList.email}
                    </Link>
                  )}
                </div>
                {footerDataList?.footerSocialMedia && (
                  <div className="sicon">
                    <ul className="flex flex-wrap justify-end gap-x-10 mt-25 mdscreen:justify-center">
                      {footerDataList.footerSocialMedia.map((item, m) => (
                        <li key={m}>
                          <Link to={item.link.url} target={item.link.target}>
                            <img
                              src={item.icon.mediaItemUrl}
                              width={20}
                              height={20}
                              loading="lazy"
                              alt={item.icon.title}
                            />
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </motion.div>
            </div>
          </div>
        </div>
        <div className="copyright text-white-100 pb-20 pt-35 bg-grey-100">
          <div className="container-fluid-md">
            <div className="copyright-main flex flex-col mdscreen:items-center">
              <motion.div variants={animFade}>
                <span className="text-12 font-390 opacity-[0.85]">
                  Entara Lodges & Camps.
                </span>
              </motion.div>
              <motion.div variants={animFade}>
                <ul>
                  <li>All rights reserved</li>
                  {footerDataList?.termsMenu.length > 0 &&
                    footerDataList.termsMenu.map((item, n) => {
                      const url =
                        item.menu.title === "Terms & Conditions"
                          ? "/terms-conditions/?tab=terms"
                          : "/terms-conditions/?tab=privacy"
                      return (
                        <li key={n}>
                          <a href={url}>{parse(item.menu.title)}</a>
                        </li>
                      )
                    })}
                </ul>
              </motion.div>
            </div>
          </div>
        </div>
      </motion.footer>
    </React.Fragment>
  )
}

export default Footer